import axios from 'axios'

const clusters = {
    namespaced: true,
    state: {
        clusters: [],
        search: ''
    },
    mutations: {
        SET_CLUSTERS(state, clusters){
            state.clusters = clusters
        },
        UPDATE_SEARCH (state, search_text){
            state.search = search_text.toLowerCase()
        }
    },
    actions: {
        // Obtenemos el listado de las sucurssales
        clusterRequest({ commit, rootState }){

            return new Promise((resolve, reject) => {

            axios({
                method: "get",
                url: process.env.VUE_APP_CORE_HOST+"/api/store/cluster/?format=json",
                headers: {
                    "Authorization": "Bearer " + rootState.auth.loggedIn.access
                }
            }).then(response =>{
                    commit('SET_CLUSTERS', response.data)
                    resolve({'clusters': true})
                })
                .catch(err => {
                    reject({'clusters': false})

                })
            });
        },
        setClusterFilter({ commit }, search_text){
            commit('UPDATE_SEARCH', search_text)
        }
    },
    getters: {
        allClusters(state){
            return state.clusters
        },
        getFilter(state){
            return state.search
        },
        // activeOffersCounter(state){
        //     return state.clusters
        // },
        // inactiveOffersCounter(state){
        //     return state.clusters
        // },
        singleClusterRequest(state){
            return id => state.clusters.filter(cluster=>cluster.id==id)
        },
        getSelectedCluster(state){
            return id => state.clusters.filter(cluster=>cluster.id==id)
        }
    }
}

export default {
    clusters
}